"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  cursor: ", ";\n  pointer-events: ", ";\n\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  vertical-align: middle;\n  justify-content: center;\n\n  text-align: center;\n\n  width: ", ";\n  height: ", ";\n  padding: ", ";\n  max-width: ", ";\n\n  margin-top: ", ";\n  margin-bottom: ", ";\n  margin-left: ", ";\n  margin-right: ", ";\n\n  background-color: ", ";\n  color: ", ";\n\n  border-radius: ", ";\n\n  opacity: ", ";\n\n  transition: color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n\n  i {\n    line-height: 24px;\n  }\n\n  p {\n    width: 100%;\n    transition: color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n    color: ", ";\n\n    span {\n      ", ";\n    }\n  }\n\n  &:hover {\n    background-color: ", ";\n    color: ", ";\n\n    p {\n      color: ", ";\n    }\n  }\n\n  border: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      width: 100%;\n      text-align: center;\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var getColor = function getColor(active, disabled, theme) {
  var isBG = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var hover = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  if (disabled) {
    if (isBG) {
      return 'transparant';
    }

    return theme.palette.disabled.main;
  }

  if (active) {
    if (isBG) {
      return theme.palette.primary.background;
    }

    return theme.palette.primary.main;
  }

  if (hover) {
    if (isBG) {
      return theme.palette.black.lightest;
    }

    return theme.palette.black.main;
  }

  if (isBG) {
    return 'transparant';
  }

  return theme.palette.black.main;
};

var getDimension = function getDimension(title, dimension, size) {
  if (size === 'large') {
    return 'unset';
  }

  if (dimension) {
    return dimension;
  }

  if (title) {
    return '56px';
  }

  return '44px';
};

var getOverflow = function getOverflow(size) {
  if (size === 'large') {
    return (0, _styledComponents.css)(_templateObject());
  }

  return '';
};

var ActionButton = _styledComponents["default"].div(_templateObject2(), function (props) {
  return props.disabled ? 'initial' : 'pointer';
}, function (props) {
  return props.disabled ? 'none' : '';
}, function (_ref) {
  var title = _ref.title,
      width = _ref.width,
      size = _ref.size;
  return getDimension(title, width, size);
}, function (_ref2) {
  var title = _ref2.title,
      height = _ref2.height;
  return getDimension(title, height);
}, function (props) {
  return props.size === 'large' ? props.theme.spacing(2) + 'px' : props.padding;
}, function (props) {
  return props.size === 'large' ? '96px' : 'unset';
}, function (_ref3) {
  var theme = _ref3.theme,
      margin = _ref3.margin;
  return margin || theme.spacing(2) + 'px';
}, function (_ref4) {
  var theme = _ref4.theme,
      margin = _ref4.margin;
  return margin || theme.spacing(2) + 'px';
}, function (_ref5) {
  var theme = _ref5.theme,
      marginSides = _ref5.marginSides;
  return marginSides || theme.spacing(1) + 'px';
}, function (_ref6) {
  var theme = _ref6.theme,
      marginSides = _ref6.marginSides;
  return marginSides || theme.spacing(1) + 'px';
}, function (_ref7) {
  var active = _ref7.active,
      disabled = _ref7.disabled,
      theme = _ref7.theme;
  return getColor(active, disabled, theme, true);
}, function (_ref8) {
  var active = _ref8.active,
      disabled = _ref8.disabled,
      theme = _ref8.theme;
  return getColor(active, disabled, theme);
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.shape.borderRadius + 'px';
}, function (props) {
  return props.disabled ? 0.72 : '';
}, function (_ref10) {
  var active = _ref10.active,
      disabled = _ref10.disabled,
      theme = _ref10.theme;
  return getColor(active, disabled, theme);
}, function (props) {
  return getOverflow(props.size);
}, function (_ref11) {
  var active = _ref11.active,
      disabled = _ref11.disabled,
      theme = _ref11.theme;
  return getColor(active, disabled, theme, true, true);
}, function (_ref12) {
  var active = _ref12.active,
      disabled = _ref12.disabled,
      theme = _ref12.theme;
  return getColor(active, disabled, theme, false, true);
}, function (_ref13) {
  var active = _ref13.active,
      disabled = _ref13.disabled,
      theme = _ref13.theme;
  return getColor(active, disabled, theme, false, true);
}, function (_ref14) {
  var border = _ref14.border,
      theme = _ref14.theme;
  return border ? "1px solid ".concat(theme.palette.black.lighter) : 'initial';
});

ActionButton.propTypes = {
  active: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  border: _propTypes["default"].bool,
  width: _propTypes["default"].string,
  height: _propTypes["default"].string,
  margin: _propTypes["default"].string,
  marginSides: _propTypes["default"].string,
  padding: _propTypes["default"].string,
  title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  size: _propTypes["default"].oneOf(['medium', 'large'])
};
ActionButton.defaultProps = {
  margin: '4px',
  padding: '4px',
  active: false,
  disabled: false,
  border: false,
  size: 'medium'
};
var _default = ActionButton;
exports["default"] = _default;